import { useQuery } from "@tanstack/react-query";

import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";

export const useQuoteRequestLine = (
  { id }: { id: string | undefined },
  options?: {
    enabled?: boolean;
  },
) => {
  const { data: quoteRequestLine, ...rest } = useQuery({
    ...quoteRequestLineQuery({ id }),
    enabled: options?.enabled,
  });

  return { quoteRequestLine, ...rest };
};
